import { render, staticRenderFns } from "./AppendageSelectGoods.vue?vue&type=template&id=34f5336c&scoped=true"
import script from "./AppendageSelectGoods.vue?vue&type=script&lang=js"
export * from "./AppendageSelectGoods.vue?vue&type=script&lang=js"
import style0 from "./AppendageSelectGoods.vue?vue&type=style&index=0&id=34f5336c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f5336c",
  null
  
)

export default component.exports